import {Cache} from "./Cache";

class LoginInfo extends Cache {
  constructor() {
    super();
    this.key += '_login_info';
  }
}

export const loginInfoCache = new LoginInfo();
